export const updateControls = (ctx) => {
    ctx.getControls().resetJustPressed();
};
